import { GUID_, guids } from '@appShared/guids'

export interface RouteModel {
   baseUri: string
   title: string
   uri: string
}

const routes = {
   //signUp: {
   //   title: 'Create Account',
   //   baseUri: 'sign-up',
   //   uri: 'sign-up'
   //} as RouteModel,
   title: 'Southwestern Real Estate',
   uri: ''
}

export const environment = {
   production: false,
   baseUri: 'https://test.southwesternrealagent.com',
   contentRootUri: 'property-listings',
   dealerApiUri: 'https://testportal.advantage4dealers.com/api/dealer',
   userPrincipalIdHeaderName: 'UserPrincipalId-29239E59E0924FC4',
   /* guids below used to obfuscate in PROD */
   [GUID_.E567D0E4603F4A7580212E770DE079AA]: '1204683634232208',                 //serviceLayerClientId
   [GUID_.D9A8BADB30FA4EDE975EAE987AABFBD4]: 'e91ee2fd0f634a28aa43e0223c3864bf', //serviceLayerClientSecret,
   routes
}
